<script lang="ts">
  import type { PriceItem } from "$lib/types/spotPriser";
  import getPriceToPx from "./priceToPx";
  import { localeRound } from "$lib/utils/math";

  const chartHeight = 48;

  let {
    hours,
    hoursIndex,
    currentHour,
    prices,
    includeStotte = false,
    showRatio = true,
  }: {
    hours: number[];
    hoursIndex: number[];
    currentHour: number | null;
    prices: undefined | PriceItem[];
    includeStotte?: boolean;
    showRatio?: boolean;
  } = $props();

  let priceToPx = $derived(prices && getPriceToPx(prices, chartHeight, showRatio));
</script>

<ul class="list-none p-0 gap-x-1px gap-y-6px flex flex-wrap my-1 text-sm">
  {#each hours as hour, i (`${hour}-${i}`)}
    {@const hh = String(hour).padStart(2, "0")}
    {@const item = prices && prices[hoursIndex[i]]}
    {@const now = currentHour && hoursIndex[i] === currentHour}

    <li
      class:current={now}
      class="inline-block min-h-3rem min-w-3rem flex flex-col gap-1px relative bg-$bg text-sm"
    >
      <strong
        class="grid place-items-center text-center relative z-1 whitespace-nowrap isolate h-full leading-none"
      >
        <small class="block relative z-1 whitespace-nowrap text-center time-container">
          {#if now}
            <span class="text-sm font-400">Nå</span>
          {/if}
          <small class="font-400" class:lowercase={now}>Kl</small>
          <span class="text-sm">{hh}</span>
        </small>

        <span
          class="px-1"
          class:font-normal={includeStotte && item?.hasStromstottePris}
          class:text-sm={includeStotte && item?.hasStromstottePris}
          class:line-through={includeStotte && item?.hasStromstottePris}
        >
          {#if item}
            {localeRound(item.pris)}
          {/if}
        </span>

        <span class="px-1">
          {#if includeStotte && item?.hasStromstottePris}
            {localeRound(item.hasStromstottePris)}
          {/if}
        </span>

        <span class="block absolute inset-0 z--1" style="height: {chartHeight}px">
          {#if item && priceToPx}
            {@const hPx = priceToPx(item.pris)}

            <span
              class="block w-full absolute right-0 overflow-hidden"
              style="height:{hPx > -1 ? hPx : -1 * hPx}px; top:{chartHeight - hPx}px;"
            >
              <span
                class="absolute z-1 w-full left-0"
                style="height:{chartHeight}px; background:linear-gradient(var(--naust),var(--geitrams) 7.25%, var(--aurora) 12.5%, var(--aurora) 50%, var(--aurora) calc(100% - 1px), var(--glod)); top:-{chartHeight -
                  hPx}px;"
              ></span>
            </span>
          {/if}
        </span>
      </strong>
    </li>
  {/each}
</ul>

<style lang="postcss">
  .current {
    box-shadow: 0 -3px var(--lysning);
  }
</style>
